// extracted by mini-css-extract-plugin
module.exports = {"customSelectSearch":"Index_customSelectSearch__ryHjn"};